<template>
  <div
    ref="scrollBar"
    class="kye-dept-multiple-tree"
    style="height:calc(60vh - 110px);overflow-y:auto;width:368px;scroll-behavior: smooth;"
  >
    <KyeOrgTree
      class="kye-dept-multiple-tree-list"
      v-if="authTree[0]"
      :check-strictly="checkStrictly"
      :show-checkbox="false"
      ref="tree"
      :accordion="accordion"
      highlight-current
      node-key="id"
      :data="authTree"
      :expand-on-click-node="false"
      :default-checked-keys="defaultCheckedKeys"
      :default-expanded-keys="defaultExpandedKeys"
      :props="{label: 'name', children: 'children'}"
      :filter-node-method="filterNode"
      @node-expand="noddExpand"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>
          <el-checkbox
            :disabled="!!data.disabled"
            :indeterminate="!checkStrictly && ((checkedMapDept[data.id] && checkedMapDept[data.id].indeterminate))"
            :value="
              (checkedMapDept[data.id] && checkedMapDept[data.id].isChecked) ||
              departmentIdRouteStatus(data) ||
              false
            "
            @change="currentNodeChange(data)"
          ></el-checkbox>
        </span>
        <span @click.stop="handleClickLabel(node, data)" :item-id="data.id">
          <slot name="treeLabel" :node="node" :data="data" :checkedMapDept="checkedMapDept">
            {{ node.label }}
          </slot>
        </span>
      </span>
    </KyeOrgTree>
    <div v-if="init && !load" class="kye-dept-multiple-nodata">
      <img class="kye-dept-multiple-nodata-img" src="../../../assets/images/no-auth.png"/>
      <p>无组织查看权限，<span class="kye-dept-multiple-nodata-text">可通过关键字查询</span></p>
    </div>
  </div>
</template>

<script>
import KyeOrgTree from 'public/components/kye-tree'
export default {
  components: {
    KyeOrgTree
  },
  props: {
    checkStrictly: { // 是否不联动，true则不联动，反之
      type: Boolean,
      default: false
    },
    load: { // 是否正在加载
      type: Boolean,
      default: false
    },
    init: {
      type: Boolean,
      default: false
    },
    accordion: { // 是否每次只打开一个同级树节点展开
      type: Boolean,
      default: true
    },
    authTree: {
      type: Array,
      default: () => ([])
    },
    defaultCheckedKeys: { // 默认勾选的节点ID
      type: Array,
      default: () => ([])
    },
    defaultExpandedKeys: { // 默认勾选的节点ID
      type: Array,
      default: () => ([])
    },
    ids: {
      type: Array,
      default: () => ([])
    },
    setCurrentNode: Function,
    orgTreeDeptMap: { // 平铺的组织树对象
      type: Object,
      default: () => ({})
    },
    orgTreeDeptData: { // 组织树数据
      type: Object,
      default: () => ({})
    },
    searchCheckedNode: { // 模糊搜索匹配后是否直接选中
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      checkedMapDept: {},
    }
  },
  computed: {
    // 已选中的节点
    checkedNodeList() {
      const checkedKeys = Object.keys(this.checkedMapDept).filter(id => this.checkedMapDept[id] && this.checkedMapDept[id].isChecked)
      return this.computedCheckedNodeList(checkedKeys)
    },
  },
  methods: {
    // 设置选中的状态
    setSomeCheckedMapDept (id, key = 'isChecked', val = true) {
      const checkedMapDept = this.checkedMapDept
      if (!checkedMapDept[id]) {
        this.$set(checkedMapDept, id, {})
        this.$set(checkedMapDept, id, {
          isChecked: false,
          indeterminate: false,
        })
      }
      this.$set(checkedMapDept[id], key, val)
      this.$set(checkedMapDept[id], 'indeterminate', false)
    },
    // 再次打开弹窗时，先清楚所有的状态，再根据this.setCheckedKeys()勾选默认的值
    clearTreeStatus () {
      this.checkedMapDept = {}
    },
    // 根据节点路径返回判断是否选中。
    departmentIdRouteStatus (data) {
      const checkStrictly = this.checkStrictly
      const checkedMapDept = this.checkedMapDept
      const { departmentIdRoute, id } = data || {}
      const departmentIdRouteSplit = (departmentIdRoute && departmentIdRoute.split('/').filter(id => !!id)) || []
      const isChecked = departmentIdRouteSplit.length && departmentIdRouteSplit.some(ele => checkedMapDept[ele] && checkedMapDept[ele].isChecked)
      // 如果被选中，则存入状态中
      isChecked && !checkStrictly && this.setSomeCheckedMapDept(id)
      return !checkStrictly && isChecked
    },
    setCheckedKeys (ids = this.defaultCheckedKeys) {
      this.clearTreeStatus()
      const checkedMapDept = this.checkedMapDept
      ids.forEach(id => {
        // 如果存在了就不在反选状态了
        if (id) {
          if (!checkedMapDept[id]) {
            const data = this.orgTreeDeptMap[id]
            if (data) {
              const { children } = data
              this.$set(checkedMapDept, id, {
                isChecked: true,
                indeterminate: false,
              })
              !this.checkStrictly && children.forEach(childId => {
                const isString = typeof childId === 'string'
                const id = isString ? childId : (childId ? childId.id : '')
                id && this.$set(checkedMapDept, id, {
                  isChecked: true,
                  indeterminate: false,
                })
              })
            }
          }
        }
      })
      !this.checkStrictly && this.setIdsNodeStatus(ids)
      this.$emit('getCheckedNodeList', this.checkedNodeList)
    },
    setIdsNodeStatus (ids) {
      ids.forEach(id => {
        const data = this.orgTreeDeptMap[id]
        const checkedMapDept = this.checkedMapDept
        if (data) {
          const { parentId, ids } = data
          const parentNode = this.orgTreeDeptMap[parentId]
          if (!checkedMapDept[parentId] && parentNode) {
            const children = parentNode.children || []
            const leng = children.length
            const isChecked = leng && parentNode.children.every(x => checkedMapDept[x] && checkedMapDept[x].isChecked)
            const indeterminate = leng && parentNode.children.some(x => checkedMapDept[x] && checkedMapDept[x].isChecked)
            this.$set(checkedMapDept, parentId, {
              isChecked,
              indeterminate,
            })
          }
          ids.split(',').forEach(id => {
            const checkedMapDeptItem = checkedMapDept[id]
            if (!checkedMapDeptItem) {
              this.$set(checkedMapDept, id, {
                isChecked: false,
                indeterminate: true,
              })
            } else {
              !checkedMapDeptItem.isChecked && (checkedMapDeptItem['indeterminate'] = true)
            }
          })
        }
      })
    },
    // 过滤后的节点
    filterNode (val, data) {
      let flag = val === data.id
      if (flag) {
        this.setCheckedDept(this.ids)
      }
      return flag
    },
    // 展开指定的部门，并且滚动到该元素所在位置
    setCheckedDept (ids) {
      // 展开指定的部门，并且滚动到该元素所在位置
      this.$refs.tree.setCurrentKey(ids[0])
      setTimeout(_ => {
        let dom = this.$refs.scrollBar.querySelector('.el-tree-node.is-expanded.is-current')
        if (dom) {
          let top = dom.offsetTop - 26
          this.$refs.scrollBar.scrollTop = top
        }
      }, 20)
    },
    // 更新子级的状态,仅判断更改子级的状态
    updateOneChildrenStatus (node, data) {
      // 展开的时候，判断父级是否被勾选
      const { id, children } = data
      const checkedMapDept = this.checkedMapDept
      const checked = checkedMapDept[id] && checkedMapDept[id].isChecked
      // 存在子级，勾选子级
      if (children) {
        children.forEach(child => {
          if (!checkedMapDept[child.id]) {
            this.$set(checkedMapDept, child.id, {})
            this.$set(checkedMapDept[child.id], 'isChecked', false)
          }
          checkedMapDept[child.id].isChecked = checkedMapDept[child.id].isChecked || checked
        })
      }
    },
    // 点击label时展开下级的逻辑
    handleClickLabel (node, data) {
      node.expanded = !node.expanded
      // 如果不联动，则没有这些操作。仅勾选自己的选项，且不关联子节点
      if (this.checkStrictly) {
        return
      }
      this.updateOneChildrenStatus(node, data)
    },
    // 输入框值改变时的事件。
    currentNodeChange (data) {
      let allow = true
      const setCurrentNode = this.setCurrentNode
      // 增加选中之前的回调，支持同步与异步
      if (setCurrentNode && typeof setCurrentNode === 'function') {
        allow = setCurrentNode(data, this.checkedNodeList, this.orgTreeDeptMap)
        if (allow.then) {
          allow.then((_) => {
            _ && this.handleCheckChange(data)
          })
        } else {
          allow && this.handleCheckChange(data)
        }
      } else {
        this.handleCheckChange(data)
      }
    },
    // 输入框值改变时的事件的逻辑处理
    async handleCheckChange (data, isDeleteAll = false, isInputSeach) {
      this.handleChangeRow(data, isDeleteAll, isInputSeach)
      this.$emit('getCheckedNodeList', this.checkedNodeList)
    },
    // 更新节点的状态
    handleChangeRow(data, isDeleteAll = false, isInputSeach) {
      let { id, children = [], parentId } = data
      const checkedMapDept = this.checkedMapDept
      const deptMap = this.orgTreeDeptMap || {}

      const checkStrictly = this.checkStrictly // 是否联动

      // 联动的时候 判断父级是否被勾选了。如果父级被选了，那么子级都被勾选. 这里是为了处理回显时 减少计算的容错处理
      if (!checkStrictly && deptMap[parentId] && checkedMapDept[parentId] && checkedMapDept[parentId].isChecked) {
        const broList = deptMap[parentId].children
        broList.forEach(ele => {
          if (!checkedMapDept[ele]) {
            this.$set(checkedMapDept, ele, {})
            this.$set(checkedMapDept[ele], 'isChecked', true)
            this.$set(checkedMapDept[ele], 'indeterminate', false)
          }
        })
      }

      // 判断是否存在于本地的选择对象中，如果没有则给初始值
      if (!checkedMapDept[id]) {
        this.$set(checkedMapDept, id, {})
        this.$set(checkedMapDept[id], 'isChecked', false)
        this.$set(checkedMapDept[id], 'indeterminate', false)
      }
      if (!isInputSeach) {
        // 反选当前节点的状态
        this.$set(checkedMapDept[id], 'isChecked', !checkedMapDept[data.id].isChecked)
        // 如果本身被勾选，则去除半选
        checkedMapDept[data.id].isChecked && this.$set(checkedMapDept[id], 'indeterminate', false)
      }
      this.$emit('current-node-change', data)
      // 如果不联动，则没有这些操作。仅勾选自己的选项，且不关联子节点
      if (checkStrictly && !isDeleteAll) {
        return
      }
      // 判断是否存在子级，同步父级的状态
      // 特殊情况，当是搜索框搜索的结果，则是只有三级，第三级的children是空，这个时候需要使用全量的树去判断是否为 真的为空
      if (!children.length) {
        const isExitChildren = (deptMap[id] && deptMap[id].children.length)
        if (isExitChildren) {
          children = deptMap[id].children
        }
      }
      // 清除的操作需要执行，删除所有的状态
      if (children && (!checkStrictly || isDeleteAll)) {
        this.setChildrenStatus(children, { isInputSeach, id, isDeleteAll })
      }
      // 判断是否拥有父节点，递归反选父节点状态 只能适用于父节点存在的情况
      if (parentId) {
        this.setParentStatus(parentId, isInputSeach)
      }
    },
    // 递归设置子节点的状态
    setChildrenStatus(children, conf) {
      const { id: rootId } = this.orgTreeDeptData || {}
      const { isInputSeach, id, isDeleteAll } = conf
      const deptMap = this.orgTreeDeptMap || {}
      const that = this
      const checkedMapDept = this.checkedMapDept
      children.forEach(function iter(child) {
        let childId = child.id || child
        // 初始化状态
        if (!checkedMapDept[childId]) {
          that.$set(checkedMapDept, childId, {})
          that.$set(checkedMapDept[childId], 'isChecked', false)
          that.$set(checkedMapDept[childId], 'indeterminate', false)
        }
        // 模糊搜索时不做处理
        if (!isInputSeach) {
          that.$set(checkedMapDept[childId], 'isChecked', checkedMapDept[id].isChecked)
          checkedMapDept[childId].isChecked && that.$set(checkedMapDept[childId], 'indeterminate', false)
        }
        // 如果是点击删除按钮，则全部取消半选
        if (id === rootId && isDeleteAll) {
          that.$set(checkedMapDept[childId], 'indeterminate', false)
        }
        // 递归子节点，如果存在的话
        if (child.children && child.children.length) {
          child.children.forEach(iter)
        } else {
          // 如果childId是id,而不是子节点的集合，判断children是否真的为空
          const childChildren = deptMap[childId] && deptMap[childId].children
          if (childChildren) {
            childChildren.forEach(iter)
          }
        }
      })
    },
    // 处理模糊匹配改变的值的状态
    processingSearchCheckedParantNodeStatus (parentNode) {
      const { ids = '' } = parentNode
      const checkedMapDept = this.checkedMapDept
      const idsArr = ids.split(',').filter(id => !!id)
      // 如果是输入框模糊搜索 并选中后设置为选中的数据时。比如选择顶级跨越集团，但是这个时候选择某个子节点，比如又搜索 技术中心，这个时候技术中心的父级也需要被选中，因为顶层的跨越集团被选中了。但实际他并没有被选中。这个时候需要从链路来解决，链路是父级们的节点。
      // 如果他们之一被选中了。这个时候就强制更新自己为选中。
      // 注意，这个时候的功能仅限于输入框模糊匹配并选中的场景，在实际操作时 不能使用，因为会永远不能被取消状态。
      const someParentNodeIsChecked = this.searchCheckedNode && idsArr.length && idsArr.some(id => checkedMapDept[id] && checkedMapDept[id].isChecked)
      return someParentNodeIsChecked
    },
    // 递归设置父节点状态 反选与是否选择
    setParentStatus(parentId, isInputSeach) {
      const checkedMapDept = this.checkedMapDept
      const deptMap = this.orgTreeDeptMap || {}
      const deptMapKeys = Object.keys(deptMap)
      const parentNode = deptMap[parentId] || {}
      if (!parentNode) {
        return
      }
      if (!checkedMapDept[parentId]) {
        this.$set(checkedMapDept, parentId, {})
        this.$set(checkedMapDept[parentId], 'isChecked', false)
        this.$set(checkedMapDept[parentId], 'indeterminate', false)
      }
      if (checkedMapDept[parentId].hasOwnProperty('indeterminate')) {
        this.$set(checkedMapDept[parentId], 'indeterminate', false)
      }
      // 处理模糊匹配改变的值的状态
      const someParentNodeIsChecked = isInputSeach && this.processingSearchCheckedParantNodeStatus(parentNode)
      if (parentNode && Array.isArray(parentNode.children) && parentNode.children.length) {
        const parentNodeChildren = parentNode.children.map(child => {
          let id = typeof child === 'object' ? child.id : child
          return id || ''
        }).filter(id => !!id)
        if (!parentNodeChildren.length) return
        // parentNode.children里面存储的是 id // 如果不是id则需要转换判断
        const isAllChecked = someParentNodeIsChecked || parentNodeChildren.every(id => checkedMapDept[id] && checkedMapDept[id].isChecked)
        if (isAllChecked) {
          checkedMapDept[parentId].isChecked = true
          this.$set(checkedMapDept[parentId], 'indeterminate', false)
        } else {
          checkedMapDept[parentId].isChecked = false
          this.$set(checkedMapDept[parentId], 'indeterminate', false)
          let isSomeChecked = parentNodeChildren.some(id => checkedMapDept[id] && checkedMapDept[id].isChecked)
          if (isSomeChecked) {
            this.$set(checkedMapDept[parentId], 'indeterminate', true)
          }
        }
        // 如果子级存在半选，则勾选,并存在于右侧的树中
        const isHalfIndeterminate = parentNodeChildren.some(id => checkedMapDept[id] && checkedMapDept[id].indeterminate && deptMapKeys.indexOf(id) > -1)
        if (isHalfIndeterminate) {
          this.$set(checkedMapDept[parentId], 'indeterminate', true)
        }
      }
      if (parentNode && parentNode.parentId) {
        this.setParentStatus(parentNode.parentId, isInputSeach)
      }
    },
    // 展开下级的操作
    noddExpand (nodeData, node, instance) {
      const { data } = node
      if (this.checkStrictly) {
        return
      }
      this.updateOneChildrenStatus(node, data)
    },
    // 联动的情况下，搜索后子节点的情况处理
    choosedSetChildrenStatus(id) {
      if (!this.checkStrictly) {
        const data = this.orgTreeDeptMap[id] || {}
        // 如果是有子级，且本身被勾选，则把子级勾选上，因为这里的结构是三级，会展开子级。
        // 有一种情况是 搜索的一个子级，然后带出了父级，但是直接勾选父级，这个时候，父级还有其他子级未被显示出来
        const checkedMapDept = this.checkedMapDept
        const { isChecked } = checkedMapDept[id] || {}
        const { children } = data
        if (children && isChecked) {
          children.forEach(child => {
            const childId = child.id || child
            if (!checkedMapDept[childId]) {
              this.$set(checkedMapDept, childId, {})
              this.$set(checkedMapDept[childId], 'isChecked', false)
              this.$set(checkedMapDept[childId], 'indeterminate', false)
            }
            this.$set(checkedMapDept[childId], 'isChecked', true)
            this.$set(checkedMapDept[childId], 'indeterminate', false)
          })
        }
      }
    },
    // 计算选中的节点，如果子节点都被选中则只展示父节点。否则选中当前节点
    computedCheckedNodeList (checkedKeys) {
      let checkedNodes = []
      if (this.checkStrictly) {
        return checkedKeys
      }
      const deptMap = this.orgTreeDeptMap
      const deptMapKeys = Object.keys(deptMap)
      // 如果checkedKeys 存在 -11 即跨越集团 则仅返回跨越集团，防止过多的循环
      const { id: rootId } = this.orgTreeDeptData || {}
      if (checkedKeys.indexOf(rootId) > -1) {
        checkedNodes = [rootId]
        checkedKeys = [rootId]
      } else {
        checkedNodes = checkedKeys.filter(function iter(checkedId) {
          const { parentId } = typeof checkedId === 'string' ? (deptMap[checkedId] || {}) : (checkedId || {})
          // 如果父级存在,则说明所有的子级都不需要存在 并且存在于全量树中才能被选中
          return parentId && checkedKeys.indexOf(parentId) === -1 && deptMapKeys.indexOf(checkedId) > -1
        })
      }
      return checkedNodes
    },
    // 取消所有的状态，在关闭弹窗或者删除状态下
    deleteRootStatusOfLinked () {
      this.clearTreeStatus()
      this.$emit('getCheckedNodeList', this.checkedNodeList)
    },
  }
}
</script>
<style lang="less" scoped>
.kye-dept-multiple-tree {
  .kye-dept-multiple-nodata {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #B0B3BF;
    margin-top: 60px;
    &-img {
      width: 310px;
      height: 200px;
    }
    &-text {
      color: #1B2240;
    }
    p {
      margin-top: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-dept-multiple/components/dept-tree.vue